import { Image } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

const ImageWrapper = styled.div`
  align-items: center;
  background: var(--color-bg-body);
  border: 1px solid var(--color-accent-secondary-weaker);
  border-radius: var(--size-border-radius-md);
  display: flex;
  flex: 1;
  height: 100%;

  ${Image.S.Image} {
    border-radius: var(--size-border-radius-md);
    height: 100%;
    object-fit: cover;
    width: 100%;
  }
`;

const ImageThumbWrapper = styled.div`
  align-items: center;
  border: 1px solid var(--color-accent-secondary-weaker);
  border-radius: var(--size-border-radius-md);
  cursor: pointer;
  display: flex;
  overflow: hidden;

  ${Image.S.Image} {
    max-height: 88px;
    max-width: 80px;
    min-height: 88px;
    min-width: 80px;
  }
`;

const ProductGallery = styled.div`
  display: flex;
  flex-direction: row-reverse;
  max-height: 450px;
  max-width: 450px;
  min-width: 100%;

  .swiper-button-prev,
  .swiper-button-next {
    background: var(--color-bg-body);
    border: 2px solid var(--color-accent-secondary-default);
    border-radius: var(--size-border-radius-circle); //
    color: var(--color-accent-secondary-default);
    font-size: 10px;
    height: 32px;
    padding: 12px;
    width: 32px;
  }

  .swiper-slide-visible {
    opacity: 0.5;
  }
  .swiper-slide-thumb-active {
    opacity: 1;
    ${ImageThumbWrapper} {
      border: 1px solid var(--color-accent-primary-weak);
    }
  }
`;

export { ImageThumbWrapper, ImageWrapper, ProductGallery };
